import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';
import { listTimeZones } from '../utils/assessmentSchedule';

export type AssessmentScheduleValues = {
  opensAt: string;
  closesAt: string;
  timeZone: string;
};

interface AssessmentScheduleFieldsProps {
  value: AssessmentScheduleValues;
  onChange: (value: AssessmentScheduleValues) => void;
}

function AssessmentScheduleFields({ value, onChange }: AssessmentScheduleFieldsProps) {
  const timeZoneOptions = useMemo(() => listTimeZones(), []);

  return (
    <>
      <TextField
        label="Opens"
        type="datetime-local"
        value={value.opensAt}
        onChange={(event) => onChange({ ...value, opensAt: event.target.value })}
        InputLabelProps={{ shrink: true }}
        fullWidth
      />
      <TextField
        label="Closes"
        type="datetime-local"
        value={value.closesAt}
        onChange={(event) => onChange({ ...value, closesAt: event.target.value })}
        InputLabelProps={{ shrink: true }}
        fullWidth
      />
      <Autocomplete
        options={timeZoneOptions}
        value={value.timeZone}
        onChange={(_, timeZone) => timeZone && onChange({ ...value, timeZone })}
        disableClearable
        renderInput={(params) => (
          <TextField {...params} label="Time Zone" helperText="Open and close times are in this time zone." />
        )}
      />
    </>
  );
}

export default AssessmentScheduleFields;
